import * as types from "../types";

export const getRecording = ({ id }) => ({
  type: types.GET_RECORDING,
  request: {
    url: `/recordings/${id}`,
    method: "GET"
  }
});

export const createExhibitorRecording = ({ exhibitorId, recording }) => ({
  type: types.CREATE_EXHIBITOR_RECORDING,
  request: {
    url: `/exhibitors/${exhibitorId}/recordings`,
    method: "POST",
    data: {
      recording
    }
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }, { data: newRecording }) => {
        return { data: { ...data, recordings: [...(data.recordings || []), newRecording] } };
      }
    }
  }
});

export const updateRecording = ({ id, recording }) => ({
  type: types.UPDATE_RECORDING,
  request: {
    url: `/recordings/${id}`,
    method: "PATCH",
    data: {
      recording
    }
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }, { data: newRecording }) => {
        return {
          data: { ...data, recordings: data.recordings.map(d => (d.id === id ? newRecording : d)) }
        };
      }
    }
  }
});

export const deleteRecording = ({ id }) => ({
  type: types.DELETE_RECORDING,
  request: {
    url: `/recordings/${id}`,
    method: "DELETE"
  },
  meta: {
    mutations: {
      [types.GET_EXHIBITOR]: ({ data }) => {
        return { data: { ...data, recordings: data.recordings.filter(d => d.id !== id) } };
      }
    }
  }
});
